module.exports = __webpack_public_path__ + "static/media/c-prompt.90102883.ico";